/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class PartyGrid extends SiteEntityGrid<PartyRow, any> {
        protected getColumnsKey() { return 'Data.Party'; }
        protected getDialogType() { return PartyDialog; }
        protected getIdProperty() { return PartyRow.idProperty; }
        protected getLocalTextPrefix() { return PartyRow.localTextPrefix; }
        protected getService() { return PartyService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

        }
    }
}